import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import NodeWrapper from "./NodeWrapper";
import useHandleConnected from "./useHandleConnected";
import { FindReplace } from "@mui/icons-material";

/**
 * Regex Node — Extrair/validar com expressao regular.
 *
 * data.pattern: string — regex pattern
 * data.flags: string — flags (g, i, m, etc)
 * data.sourceVar: string — variavel de entrada
 * data.outputVar: string — variavel para resultado (match/groups)
 * data.mode: "match" | "test" | "replace" | "extract"
 * data.replaceWith: string — valor de substituicao (modo replace)
 *
 * Saidas: handle "match" (regex deu match), handle "noMatch" (nao deu match)
 */
const RegexNode = memo(({ id, data, isConnectable, selected }) => {
  const getHandleClass = useHandleConnected(id);
  const pattern = data?.pattern || "";
  const flags = data?.flags || "i";
  const mode = data?.mode || "test";

  const modeLabels = { match: "Match", test: "Testar", replace: "Substituir", extract: "Extrair" };

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<FindReplace />}
      title="Regex"
      color="#AD1457"
      bgColor="#FCE4EC"
      noSource
      isConnectable={isConnectable}
      selected={selected}
      minWidth={210}
    >
      <div style={{
        background: "#fff", border: "1px solid #e0e0e0",
        borderRadius: 6, padding: "5px 10px", fontSize: 11,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#AD1457", borderRadius: 4, padding: "1px 8px",
          }}>{modeLabels[mode] || mode}</span>
        </div>
        {pattern && (
          <div style={{
            marginTop: 4, fontFamily: "'Fira Code', monospace",
            color: "#AD1457", fontSize: 11, fontWeight: 600,
          }}>
            /{pattern}/{flags}
          </div>
        )}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 8 }}>
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "flex-end",
          gap: 6, position: "relative", paddingRight: 4,
        }}>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#4caf50", borderRadius: 4, padding: "2px 10px",
          }}>MATCH</span>
          <Handle type="source" position={Position.Right} id="match"
            className={getHandleClass("source", "match")}
            style={{
              position: "absolute", top: "50%", right: -13,
              transform: "translateY(-50%)",
              cursor: "crosshair",
            }} isConnectable={isConnectable} />
        </div>
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "flex-end",
          gap: 6, position: "relative", paddingRight: 4,
        }}>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#f44336", borderRadius: 4, padding: "2px 10px",
          }}>SEM MATCH</span>
          <Handle type="source" position={Position.Right} id="noMatch"
            className={getHandleClass("source", "noMatch")}
            style={{
              position: "absolute", top: "50%", right: -13,
              transform: "translateY(-50%)",
              cursor: "crosshair",
            }} isConnectable={isConnectable} />
        </div>
      </div>
    </NodeWrapper>
  );
});

RegexNode.displayName = "RegexNode";
export default RegexNode;
